import { Action } from 'shared/store/types';
import { defaultState } from './constants';
import actions from './actionType';

const getReviews = (state = defaultState, action: Action) => {
  const { type, payload, isLoading, add_reviews } = action;
  switch (type) {
    case actions.LOAD_REVIEWS:
      return {
        ...state,
        isLoading: isLoading,
      };
    case actions.SUCCESS_REVIEWS: {
      let reviewLeft_flag = true;
      if (payload.reviews.length < 20) {
        reviewLeft_flag = false;
      }
      if (add_reviews) {
        const { Reviews } = state;
        Reviews.reviews = [...(Reviews?.reviews || []), ...payload.reviews];
        return {
          ...state,
          Reviews,
          reviewLeft: reviewLeft_flag,
        };
      }
      return {
        ...state,
        Reviews: payload,
        reviewLeft: reviewLeft_flag,
        isLoading: isLoading,
      };
    }
    case actions.USER_PARAM_CHANGE:
      return {
        ...state,
        ...payload,
      };
    case actions.REVIEWS_OVER:
      return {
        ...state,
        reviewLeft: payload,
      };
    case actions.ALLREVIEWS_LIKE_REVIEW: {
      const { reviewId, count } = payload;
      const { Reviews } = state;
      const { reviews } = Reviews;
      const updatedReviews = [...reviews];
      if (reviews) {
        const indexOfReviewId = updatedReviews?.findIndex(
          (review) => review.id === reviewId
        );
        if (updatedReviews[indexOfReviewId]) {
          updatedReviews[indexOfReviewId].isLikedByUser =
            !updatedReviews[indexOfReviewId].isLikedByUser;
          updatedReviews[indexOfReviewId].likeCount = count;
          return {
            ...state,
            Reviews: {
              ...Reviews,
              reviews: updatedReviews,
            },
          };
        }
      }
      return state;
    }
    case actions.ERROR:
      return {
        ...state,
        isLoading: isLoading,
      };
    default:
      return state;
  }
};

export default getReviews;
